import styled from 'styled-components';
export const ImagesWrapper = styled.section `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.4%;

  ${props => props.theme.mixins.mobile(`
    display: flex;
    flex-direction: column;
   
    > .item + .item {
      margin-top: 5px;
    }
  `)}

  a, img {
    display: block;
  }

  img { 
    width: 100%;
  }
`;
